import React from "react";

function BouncyBallz() {
  return (
    <>
      <iframe src="https://my.spline.design/portfoliobanner-505f85624cb20fe265a460d23e395716/" allow="full"></iframe>
    </>
  );
}

export default BouncyBallz;
